import type { ModalProps } from "@replo/design-system/components/modal/Modal";

import * as React from "react";

import {
  ModalContent,
  ModalDescription,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from "@replo/design-system/components/modal/Modal";
import twMerge from "@replo/design-system/utils/twMerge";

interface SplitModalProps extends ModalProps {
  media: React.ReactNode;
}

function SplitModal({
  media,
  title,
  description,
  children,
  footer,
  open,
  onOpenChange,
  dismissable = true,
  showCloseButton = true,
  size,
  className,
  UNSAFE_className,
  trigger,
}: SplitModalProps) {
  return (
    <ModalRoot
      open={open}
      onOpenChange={onOpenChange}
      disablePointerDismissal={!dismissable}
    >
      {trigger && <ModalTrigger>{trigger}</ModalTrigger>}
      <ModalContent
        showCloseButton={showCloseButton}
        size={size}
        className={className}
        UNSAFE_className={twMerge("p-0 overflow-hidden", UNSAFE_className)}
      >
        <div className="grid grid-cols-[1fr_1fr]">
          <div className="flex items-center justify-center">{media}</div>

          <div
            className={twMerge(
              "flex flex-col justify-between gap-8",
              size === "lg" ? "p-8" : "p-6",
            )}
          >
            {(title || description) && (
              <ModalHeader>
                <div className="flex items-center justify-between gap-2">
                  {title && <ModalTitle>{title}</ModalTitle>}
                </div>
                {description && (
                  <ModalDescription>{description}</ModalDescription>
                )}
              </ModalHeader>
            )}
            {children}
            {footer && <div className="flex flex-col gap-3">{footer}</div>}
          </div>
        </div>
      </ModalContent>
    </ModalRoot>
  );
}

export { SplitModal };
